'use client';
import { IFetchBundleSchema } from '@bitmap/contracts';
import { BundleContext } from '@/src/packages/components/pages/Bundle/BundleContext';
import { Container } from '@/src/packages/components/ui/Container';
import { BundleModal } from '@/src/packages/components/pages/Bundle/BundleModal';
import { BundleHeader } from '@/src/packages/components/pages/Bundle/BundleHeader';
import { PageSectionStack } from '@/src/packages/components/templates/PageSectionStack';
import { IReview } from '@/src/interfaces/generated/contentful';
import { BundleProducts } from '@/src/packages/components/pages/Bundle/BundleProducts';
import { ProductReviews } from '@/src/packages/components/pages/Product/ProductReviews';


export type IBundlePage = {
  bundle: IFetchBundleSchema;
  reviews: IReview[];
};

export const BundlePage = (props: IBundlePage) => {
  const { bundle } = props;

  const { reviews } = props;

  return (
    <BundleContext bundle={bundle}>
      <Container className="pb-gutter">
        <BundleModal />
        <PageSectionStack>
          <BundleHeader />
          <BundleProducts />
          <ProductReviews reviews={reviews} />
        </PageSectionStack>
      </Container>
    </BundleContext>
  );
};
